<kendo-window *ngIf="_active"
              title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : '' }}"
              (close)="_closeForm()"
              (stateChange)="_onStateChanges($event)"
              class="fullWidthFormForm"
              (keydown.enter)="$event.preventDefault()">
  <form novalidate [formGroup]="_form" class="form_style">
    <div class="row special_row_margin">
      <div class="col-12 special_col_padding">
        <div class="border_sections margin-top-4">
          <div class="row">
            <div class="col-12">
              <h2 class="formsTitle">
                Security Level
                <span (click)="_edit()"
                      [class.ViewModeVisibleElement]="_pageState == 1"
                      *ngIf="_model.id != null ? (!_defaultAppRoles.includes(_model.id)) : true"
                      class="action-button action-button-viewMode">
                  <div class="action-button-icon">
                    <img src="/assets/menu/enterprise/edit-action-icon-grid.svg" />
                  </div>
                  <div class="edit-icon-text">Edit</div>
                </span>
              </h2>

              <ul class="menuButtonsList">
                <!-- <li (click)="_onEditForm()" [class.ViewModeHiddenElement]="_pageState == 1">Edit Fields</li> -->
                <!-- <li [class.ViewModeHiddenElement]="_pageState == 1" >Edit Forms</li> -->
                <!-- <li class="wikiButton">Wiki</li> -->
              </ul>
              <div class="margin-top-10 margin">
                <button kendoButton
                        class="steps_buttons_class"
                        (click)="_onCancel()">
                  <img class="backimage"
                       [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                  <span>close</span>
                </button>
                <button *ngIf="_pageState != 1 && !_defaultAppRoles.includes(_model.id)"
                        kendoButton
                        class="steps_buttons_class"
                        [disabled]="_pageState == 4 ? true : false"
                        (click)="_onSave('saveAndCopy')">
                  <img class="backimage"
                       [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                  <span>save & Copy</span>
                </button>
                <button kendoButton
                        *ngIf="_pageState != 1 && !_defaultAppRoles.includes(_model.id)"
                        class="steps_buttons_class"
                        [disabled]="_pageState == 4 ? true : false"
                        (click)="_onSave('saveAndNew')">
                  <img class="backimage"
                       [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                  <span>save & New</span>
                </button>
                <button kendoButton
                        class="steps_buttons_class"
                        (click)="_onSave('saveAndClose')"
                        *ngIf="_pageState != 1 && !_defaultAppRoles.includes(_model.id)">
                  <img class="backimage"
                       [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                  <span>save & Close</span>
                </button>
                <button kendoButton
                        *ngIf="_pageState != 1 && !_defaultAppRoles.includes(_model.id)"
                        class="steps_buttons_class"
                        [disabled]="_pageState == 4 ? true : false"
                        (click)="_onSave('save')">
                  <img class="backimage"
                       [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                  <span>save</span>
                </button>
              </div>
            </div>

            <div class="col-12">
              <div class="formsMenuSeparator"></div>
            </div>
          </div>

          <div class="row row_padding">
            <fieldset class="col-12 col-lg-6">
              <div class="form-group special_style_formgroup">
                <label class="control-label">Security Level #</label>
                <input type="text"
                       class="k-textbox writebox newFormControlWidth"
                       formControlName="name"
                       [class.ViewModeDisabledControl]="_pageState == 1"
                       required />
              </div>
              <div class="form-group special_style_formgroup">
                <label class="control-label">Security Level Description</label>
                <input type="text"
                       class="k-textbox writebox newFormControlWidth"
                       formControlName="description"
                       [class.ViewModeDisabledControl]="_pageState == 1"
                       required />
              </div>
              <div class="form-group special_style_formgroup"
                   *ngIf="_pageState == 2">
                <label for="lastname" class="control-label">Use As Base</label>
                <kendo-combobox #Kendo_Combobox_AppRole
                                [data]="_appRolesFiltered"
                                [filterable]="true"
                                (filterChange)="_handleAppRolesFilter($event)"
                                [suggest]="true"
                                (valueChange)="_handleAppRolesChange($event)"
                                formControlName="baseAppRole"
                                [placeholder]="'Choose a Security Level'"
                                [formControl]="_selectedAppRole"
                                [textField]="'name'"
                                [valueField]="'id'"
                                class="required-input current-step k-combobox bordered newFormControlWidth"
                                required>
                </kendo-combobox>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="example-wrapper">
      <div class="row no_row_margin">
        <div class="col-12 responsive_style withoutnote">
          <kendo-tabstrip (tabSelect)="_onTabSelect($event)"
                          #tabstrip
                          [tabPosition]="_kendoTabStripPosition"
                          class="gridWithNoBorderTop">
            <kendo-tabstrip-tab title="General" [selected]="true">
              <ng-template kendoTabContent>
                <div class="tabcontent tabWizGridInside">
                  <kendo-grid [data]="_generalGroupedData"
                              [resizable]="true"
                              [ngStyle]="{'max-height.px': _maxHeight}"
                              [scrollable]="_scrollable ? 'scrollable' : 'none'"
                              [class.ViewModeDisabledControl]="_pageState == 1">
                    <kendo-grid-column field="sectionCategoryName" [hidden]="true">
                      <ng-template kendoGridGroupHeaderTemplate let-value="value">
                        <span class="security-section-title font-weight-bold">{{ value }}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Object" [width]="360">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.pageTitle || dataItem.pageName}}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column #columns title="View">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'read')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canView"
                               (click)="_securityChanged('general', 'canView', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Add">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'create')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canAdd"
                               (click)="_securityChanged('general', 'canAdd', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Edit">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'update')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canEdit"
                               (click)="_securityChanged('general', 'canEdit', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Delete">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'delete')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canDelete"
                               (click)="_securityChanged('general', 'canDelete', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                  </kendo-grid>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab title="Barcloud NG Stock"
                                (tabSelect)="_onTabSelect($event)">
              <ng-template kendoTabContent #kendo_tabstrip_wrapper>
                <div #gridWrapper class="tabcontent tabWizGridInside">
                  <kendo-grid #grid
                              [resizable]="true"
                              [ngStyle]="{'max-height.px': _maxHeight}"
                              [scrollable]="_scrollable ? 'scrollable' : 'none'"
                              [data]="_stockGroupedData"
                              [class.ViewModeDisabledControl]="_pageState == 1">
                    <kendo-grid-column field="sectionCategoryName" [hidden]="true">
                      <ng-template kendoGridGroupHeaderTemplate let-value="value">
                        <span class="security-section-title font-weight-bold">{{ value || 'General' }}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Object" [width]="360">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.pageTitle || dataItem.pageName}}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="View">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'read')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canView"
                               (click)="_securityChanged('Barcloud NG Stock', 'canView', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Add">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'create')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canAdd"
                               (click)="_securityChanged('Barcloud NG Stock', 'canAdd', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Edit">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'update')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canEdit"
                               (click)="_securityChanged('Barcloud NG Stock', 'canEdit', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Delete">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'delete')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canDelete"
                               (click)="_securityChanged('Barcloud NG Stock', 'canDelete', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                  </kendo-grid>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>

            <kendo-tabstrip-tab title="Barcloud NG Asset"
                                (tabSelect)="_onTabSelect($event)">
              <ng-template kendoTabContent #kendo_tabstrip_wrapper>
                <div #gridWrapper class="tabcontent tabWizGridInside">
                  <kendo-grid #grid
                              [resizable]="true"
                              [ngStyle]="{'max-height.px': _maxHeight}"
                              [scrollable]="_scrollable ? 'scrollable' : 'none'"
                              [data]="_assetGroupedData"
                              [class.ViewModeDisabledControl]="_pageState == 1">
                    <kendo-grid-column field="sectionCategoryName" [hidden]="true">
                      <ng-template kendoGridGroupHeaderTemplate let-value="value">
                        <span class="security-section-title font-weight-bold">{{ value || 'General' }}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Object" [width]="360">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.pageTitle || dataItem.pageName}}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="View">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'read')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canView"
                               (click)="_securityChanged('Barcloud NG Asset', 'canView', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Add">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'create')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canAdd"
                               (click)="_securityChanged('Barcloud NG Asset', 'canAdd', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Edit">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'update')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canEdit"
                               (click)="_securityChanged('Barcloud NG Asset', 'canEdit', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Delete">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input *ngIf="isActionAvailable(dataItem.pageId,'delete')"
                               type="checkbox"
                               class="k-checkbox"
                               kendoCheckBox
                               [checked]="dataItem.canDelete"
                               (click)="_securityChanged('Barcloud NG Asset', 'canDelete', dataItem.pageId)" />
                      </ng-template>
                    </kendo-grid-column>
                  </kendo-grid>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
        </div>
      </div>
    </div>
    <!-- <div class="row no_row_margin" *ngIf="_pageState != 1"></div> -->
    <div class="row">
      <div class="col-12">
        <asap-forms-validation-summary *ngIf="_invalidForm"
                                       [form]="_form"
                                       [page]="'appRoles'">
        </asap-forms-validation-summary>
      </div>
    </div>
  </form>
</kendo-window>
